import React from 'react';
import { TableColumnsByIdQueryVariables, TableColumnsByIdQuery, ColumnSortOrder, TableColumnsByIdColumnsFragment, TableColumnsByIdDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  FeatureFlagsContext,
  filterOutNullAndUndefined,
  GridSortProps,
  PaginatedQueryWrapper,
  SelectionProviderChildProps
} from '../../../data-catalog-shared';

import { ColumnsValidSortFields } from '../sorting/sortProviders/ColumnsGridSortProvider';
import { TableColumnsDisplayGrid, TableColumnsGridRowData } from './TableColumnsDisplayGrid';

export type QueryVariables = TableColumnsByIdQueryVariables;
export type QueryResults = TableColumnsByIdQuery;
export type QueryResultListNode = TableColumnsByIdColumnsFragment;
export type GridRowData = TableColumnsGridRowData;

export type TableColumnsQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<ColumnsValidSortFields> & {
    readonly tableId: string;
    readonly rowCount: number | null;
    readonly hackyUpdateNumber: number;
    readonly tableVizportalId: string;
  };

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData.tablesConnection.nodes[0]?.columnsConnection;
}

export function mapResultNode(node: QueryResultListNode, resultData: QueryResults): GridRowData {
  const table = resultData.tablesConnection.nodes[0];
  const vizportalId = table.__typename === 'DatabaseTable' ? table.vizportalId : '';
  return {
    ...node,
    labels: node.labels.concat(node.upstreamColumns ? filterOutNullAndUndefined(node.upstreamColumns).flatMap(t => t.labels) : []),
    tags: filterOutNullAndUndefined(node.tags.map(t => t.name)),
    datasourceCount: node.downstreamDatasourcesConnection ? node.downstreamDatasourcesConnection.totalCount : null,
    sheetCount: node.downstreamSheetsConnection ? node.downstreamSheetsConnection.totalCount : null,
    tableId: table?.id ?? '',
    vizportalId: vizportalId,
  };
}

export function TableColumnsQueryGrid(props: TableColumnsQueryGridProps): JSX.Element {
  const { customSensitivityLabelsEnabled } = React.useContext(FeatureFlagsContext);
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={TableColumnsByIdDocument}
      partialQueryVariables={{ tableId: props.tableId, orderBy: props.orderBy as ColumnSortOrder, customSensitivityLabelsEnabled }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={mapResultNode}
      hackyUpdateNumber={props.hackyUpdateNumber}
    >
      {({ rowStore }) => (
        <TableColumnsDisplayGrid
          rowStore={rowStore}
          selectedKeys={props.selectedKeys}
          orderBy={props.orderBy}
          updateSelectionForKey={props.updateSelectionForKey}
          updateSortOrder={props.updateSortOrder}
          rowCount={props.rowCount}
          tableVizportalId={props.tableVizportalId}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
